/**
 * External dependencies
 */
import debugFactory from "debug";

/**
 * Internal Dependencies
 */
import { bootApp } from "./common";

// temp
import "assets/stylesheets/styles.scss";

import "lib/i18n";

debugFactory.enable("makerpos");

bootApp("Visual Deck");
